<div #svgDiv class="svg-item {{classes}}"></div>
